import {ApolloError} from '@apollo/client';
import {Breadcrumb, CategoryTree, Tag} from '@/__generated__/__types__';
import {useCategoryBreadcrumbsQuery, useCategoryDetailQuery, useHotSearchKeyWordsQuery} from './gql/categories.graphql';
export function useCategoryBreadCrumbs(categoryId: number): {
    data: Breadcrumb[];
    isLoading: boolean;
    error?: ApolloError;
} {
    const {
        data,
        loading: isLoading,
        error,
    } = useCategoryBreadcrumbsQuery({
        variables: {
            filters: {
                ids: {
                    eq: `${categoryId}`,
                },
            },
        },
        notifyOnNetworkStatusChange: true,
    });

    return {
        data: (data?.categoryList?.at(0)?.breadcrumbs as Breadcrumb[]) ?? [],
        isLoading,
        error,
    };
}

export function useCategoryDetail(categoryId: number): {
    data: CategoryTree[];
    isLoading: boolean;
    error?: ApolloError;
} {
    const {
        data,
        loading: isLoading,
        error,
    } = useCategoryDetailQuery({
        variables: {
            filters: {
                ids: {
                    eq: `${categoryId}`,
                },
            },
        },
        notifyOnNetworkStatusChange: true,
    });
    return {
        data: (data?.categoryList as CategoryTree[]) ?? [],
        isLoading,
        error,
    };
}

export function useHotSearchKeyWords(categoryId: number): {
    data: Tag[];
    isLoading: boolean;
    error?: ApolloError;
} {
    const {
        data,
        loading: isLoading,
        error,
    } = useHotSearchKeyWordsQuery({
        variables: {
            categoryId,
        },
        notifyOnNetworkStatusChange: true,
    });
    return {
        data: (data?.categoryTags?.items as Tag[]) ?? [],
        isLoading,
        error,
    };
}
